<form class="easy-form mb-6" [formGroup]="form">
  <fieldset class="" formGroupName="inputExamples">
    <legend>Input példák</legend>
    <mat-form-field>
      <app-easy-input
        label="Mennyiség (min: 2, max: 100)"
        formControlName="amount"
        type="number"
        [min]="2"
        [max]="100"
        [iconSuffix]="'favorite'"
        [placeholder]="'Placeholder'"
      ></app-easy-input>
    </mat-form-field>
    <label class="legend">Szöveges mezők:</label>
    <mat-form-field class="medium">
      <app-easy-input
        label="Név (közepes méretű mező)"
        formControlName="name"
        [placeholder]="'Tamás'"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field class="large">
      <app-easy-input
        label="Ország (nagy méretű mező)"
        formControlName="country"
        [placeholder]="'Mo.'"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field>
      <app-easy-input
        label="Readonly mező (se hover, se fókusz, se opacity)"
        formControlName="readonly"
        [readonly]="true"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field>
      <app-easy-input
        label="Disabled mező (itt van opacity)"
        formControlName="disabled"
      ></app-easy-input>
    </mat-form-field>
  </fieldset>
  <fieldset class="" formGroupName="selectExamples">
    <legend>Select példák</legend>

    <mat-form-field>
      <app-easy-select
        label="Egyszerű select"
        formControlName="number"
        [options]="numberOptions"
      ></app-easy-select>
      <p>Választott opció: {{ getCtrl("selectExamples.number").value }}</p>
    </mat-form-field>
    <mat-form-field class="medium">
      <app-easy-select
        label="Objektumos select (közepes, valueAttribute nélkül)"
        formControlName="numberObj"
        [options]="numberObjectOptions"
        [labelAttribute]="'name'"
      ></app-easy-select>
      <p>
        Választott opció:
        {{ getCtrl("selectExamples.numberObj").value | json }}
      </p>
    </mat-form-field>
    <mat-form-field class="large">
      <app-easy-select
        label="Objektumos MULTIselect (nagy, valueAttribute-tal, limit: 2)"
        formControlName="numberObjMulti"
        [options]="numberObjectOptions"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [limit]="2"
        [multiple]="true"
        [showSelectedLabels]="true"
      ></app-easy-select>
      <p>
        Választott opció:
        {{ getCtrl("selectExamples.numberObjMulti").value | json }}
      </p>
    </mat-form-field>
    <mat-form-field>
      <app-easy-select
        label="Objektumos MULTIselect (disabled)"
        formControlName="numberObjMultiDisabled"
        [options]="numberObjectOptions"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [multiple]="true"
        [showSelectedLabels]="true"
      ></app-easy-select>
    </mat-form-field>

    <legend>Ital típus választók</legend>
    <mat-form-field>
      <app-easy-select
        label="Ital típus (sima select, group-okkal)"
        formControlName="drinkType"
        [options]="drinkTypes"
        [labelAttribute]="'name'"
        [groupLabelAttribute]="'groupName'"
        [groupOptionsAttribute]="'options'"
        [valueAttribute]="'value'"
        [placeholder]="'válasszon'"
        [multiple]="true"
        [showSelectedLabels]="true"
      >
      </app-easy-select>
    </mat-form-field>
    <mat-form-field>
      <app-easy-select-expandable
        label="Ital típus (sima expandable-select)"
        formControlName="drinkType2"
        [options]="drinkTypes"
        [labelAttribute]="'name'"
        [groupLabelAttribute]="'groupName'"
        [groupOptionsAttribute]="'options'"
        [valueAttribute]="'value'"
        [placeholder]="'válasszon'"
        [multiple]="true"
      >
      </app-easy-select-expandable>
      <p>
        Választott opció:
        {{ getCtrl("selectExamples.drinkType2").value | json }}
      </p>
    </mat-form-field>
    <legend>Telephely típus választók</legend>
    <mat-form-field>
      <app-easy-select
        label="Telephely típus"
        formControlName="merchantType"
        [options]="merchantTypes"
        [labelAttribute]="'name'"
        [groupLabelAttribute]="'groupName'"
        [groupOptionsAttribute]="'options'"
        [valueAttribute]="'value'"
        [placeholder]="'válassz'"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>
    <mat-form-field>
      <app-easy-select
        label="Telephely típus (multi)"
        formControlName="merchantType"
        [options]="merchantTypes"
        [labelAttribute]="'name'"
        [groupLabelAttribute]="'groupName'"
        [groupOptionsAttribute]="'options'"
        [valueAttribute]="'value'"
        [placeholder]="'válassz'"
        [multiple]="true"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>
  </fieldset>
  <fieldset>
    <legend>TextArea</legend>
    <mat-form-field>
      <app-easy-textarea
        label="Sima"
        formControlName="textarea1"
        [placeholder]="'textarea placeholder'"
      ></app-easy-textarea>
    </mat-form-field>
    <mat-form-field>
      <app-easy-textarea
        label="Kötelező, maxLength, no resize"
        formControlName="textarea2"
        [resizable]="false"
        [placeholder]="'textarea placeholder'"
        [maxLength]="50"
        [showCharactersLeft]="true"
      ></app-easy-textarea>
    </mat-form-field>
    <mat-form-field>
      <app-easy-textarea
        label="Disabled"
        formControlName="textarea3"
        [placeholder]="'textarea placeholder'"
      ></app-easy-textarea>
    </mat-form-field>
  </fieldset>
  <fieldset>
    <legend>Checkbox</legend>
    <mat-form-field>
      <app-easy-checkbox
        label="Gyártók"
        formControlName="checkbox1"
      ></app-easy-checkbox>
    </mat-form-field>
    <mat-form-field>
      <app-easy-checkbox formControlName="checkbox3"></app-easy-checkbox>
    </mat-form-field>
    <mat-form-field>
      <app-easy-checkbox
        label="Checkbox2 disabled"
        formControlName="checkbox2"
      ></app-easy-checkbox>
    </mat-form-field>
    <mat-form-field>
      <app-easy-checkbox
        label="Checkbox4 readonly"
        formControlName="checkbox4"
        [readonly]="true"
      ></app-easy-checkbox>
    </mat-form-field>
    <mat-form-field>
      <app-easy-checkbox
        label="Checkbox5 required"
        formControlName="checkbox5"
      ></app-easy-checkbox>
    </mat-form-field>
  </fieldset>
</form>
